import { httpGet, httpPatch, httpPost } from '../services/http'
import authProvider from '../utils/authProvider'

const propertyApi = process.env.REACT_APP_PROPERTY_API
const uranusPropertyApi = `${process.env.REACT_APP_URANUS_PROPERTY_API}`

const PropertyProvider = {
  getOne: async (resource, params) => {
    const token = await authProvider.getToken()
    const headers = { Authorization: `Bearer ${token}` }
    const { data: response } = await httpGet({ url: `${propertyApi}/${params.id}`, config: { headers } })
    return Promise.resolve({ data: response })
  },

  update: async (resource, { data, id }) => {
    const token = await authProvider.getToken()
    const headers = { Authorization: `Bearer ${token}` }
    const { data: response } = await httpPatch({ url: `${propertyApi}/${id}`, config: { headers }, data: data })
    return Promise.resolve({ data: response })
  },

  create: async (resource, params) => {
    const data = { ...params.data }
    const token = await authProvider.getToken()
    const headers = { Authorization: `Bearer ${token}` }
    const { data: response } = await httpPost({ url: `${uranusPropertyApi}`, config: { headers }, data: data })
    return Promise.resolve({ data: response })
  },

  getList: async (resource, { filter }) => {
    const token = await authProvider.getToken()
    const headers = { Authorization: `Bearer ${token}` }
    const url = `${uranusPropertyApi}?f=${JSON.stringify(filter)}`
    const { data: response } = await httpGet({ url, config: { headers } })
    return Promise.resolve({ data: response.items, total: response.count })
  },
}

export default PropertyProvider
